import React, { useState, useEffect }  from "react";
import { URLS, httpRequest } from "./../network";
import download from "downloadjs";
import './../css/background.css';
import { SCRAPING_PAGE_TYPE, SCRAPING_PAGE_TYPE_NAME } from "./../utils";

const BackgroundProcess = (props) => {

    const [ended, setEnded] = useState([]);

    const _getCurrentProcess = () => {

        httpRequest(URLS.GET_BACKGROUND_PROCESS, null, "GET")
            .then ((response) => {
                if (!response.success) {
                    return;
                }

                setEnded(response.data);
                props.updateBackgroundCount(response.data.length);
            })
            .catch ((err) => {
                console.log("BackgroundProcess: err: ", err);
                console.log("BackgroundProcess: err: " + JSON.stringify(err));
            });
    }

    useEffect( () => {
        _getCurrentProcess();

    }, []);

    const downloadFileClick = (filePath) => (e) => {
        
        fetch(URLS.DOWNLOAD_FILE + "?file="+filePath)
            .then ((res) => {
                return res.blob();
            })
            .then ( (blob) => {
                download(blob, shortPathName(filePath), "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return httpRequest(URLS.CLEAN_BACKGROUND_PROCESS + "?file=" + filePath, null, "GET");
            })
            .then ((response) => {
                
                props.updateBackgroundCount(response.data.length);
                setEnded(response.data);
            })
            .catch( (err) => {
                this.props.errorMessage("Error descargando el archivo: " + JSON.stringify(err));
            });
    } 

    const deleteProcess = (id) => (e) => {

        httpRequest(URLS.DELETE_PROCESS, {processId: id}, "POST")
            .then ((resp) => {
                console.log ("respo: " + JSON.stringify(resp));
                _getCurrentProcess();
            })
            .catch( (err) => {
                this.props.errorMessage("Error descargando el archivo: " + JSON.stringify(err));
            });
    }
    
    const shortPathName = (pathFile) => {

        let name = "";
        const index = pathFile.lastIndexOf("/");
        if (index !== -1) {
            name = pathFile.substring(index + 1, pathFile.length);
        }
        
        return name;
    }

    const subcategoryName = (scraperName, category) => {

        if (scraperName === SCRAPING_PAGE_TYPE.Seia) {

            if (category === 1) {
                return "Pertinencia";
            }
            else if (category === 2) {
                return "Adendas";
            }
            else {
                return "Punto representativo";
            }
        }
        else if (scraperName === SCRAPING_PAGE_TYPE.PJUD) {
            return "Búsqueda por ROL";
        }
        else if(scraperName === SCRAPING_PAGE_TYPE.Bienes) {
            return "BIENES";
        }
        else if (scraperName === SCRAPING_PAGE_TYPE.SII) {
            if (category === 1) {
                return "Bienes Raíces";
            }
            else if (category === 2) {
                return "Servicio Mapa";
            }
        }
        else if (scraperName === SCRAPING_PAGE_TYPE.BoletinMineria) {
            return "Diario Oficial";
        }
    }

    const getStatus= (status) => {

        switch(status) {
            
            case 1:
                return "En Proceso";
            case 2: 
                return "Terminado";
            case 3:
                return "Falló";
            default:
                return "Esperando"
        }
    }

    return (
        <div className="seia-inner-container">
            <h3>Procesos Incompletos</h3>
            <p>
                Aqui podras encontrar los documentos terminados que posiblemente hayan fallado. <br />
                Si al momento de estar procesando un documento falla y no puede retornar el documento con los datos que alcanzo a procesar, el servidor seguira trabajando y dejara los documentos
                terminados en esta lista.
            </p>

            <div>
                <button className="btn btn-outline-primary" onClick={_getCurrentProcess}>
                    Actualizar <span className="icon">{"\u{27f3}"}</span>
                </button>
            </div>
    
            <div id="tableContainer" className="bg-result-table">
                <table className="table table-striped table-fixed">
                    <thead>
                        <tr>
                            <th scope="col">Categoría</th>
                            <th scope="col">Sub Categoría</th>
                            <th scope="col">Fecha inicio proceso</th>
                            <th scope="col">Fecha fin proceso</th>
                            <th scope="col">Estado</th>
                            <th scope="col">Items Procesados</th>
                            <th scope="col">Descargar</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ended.map( (row, index) => {
                                return (
                                    <tr key={index}>
                                        <th scope="row">{SCRAPING_PAGE_TYPE_NAME[row.scraper]}</th>
                                        <td>{subcategoryName(row.scraper, row.category)}</td>
                                        <td>{row.created_at}</td>
                                        <td>{row.end_at}</td>
                                        <td>{ getStatus(row.status)}</td>
                                        <td>{row.current_process}</td>
                                        <td>{shortPathName(row.output_file)}</td>
                                        <td><span className="icon" onClick={downloadFileClick(row.output_file)} title="Descargar">{"\u{25BC}"}</span></td>
                                        <td><span className="icon" onClick={deleteProcess(row.id)} title="Eliminar">{"\u{1F5D1}"}</span></td>
                                    </tr>
                                );
                            })   
                        }
                    
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BackgroundProcess;